<component-modal [showClose]="false" [showFooter]="false">
  <ng-container body>
    <form class="d-flex flex-column gap-3">
      <div class="logo-container mx-auto">
        <svg-icon src="assets/logo.svg" />
      </div>

      <div class="d-flex flex-column gap-2">
        <h2 class="text-center fw-bold fs-4 mb-0">Complete Your Registration</h2>

        <p class="text-center text-muted mb-0">Set up your account credentials</p>
      </div>

      <!-- Email Input (disabled for invite flow) -->
      <component-input type="email" label="Email" [value]="email()" [disabled]="true" [isClearable]="false" />

      <!-- Username Input (optional) -->
      <component-input
        type="text"
        label="Username (optional)"
        [value]="usernameControl()?.value || ''"
        [isClearable]="true"
        [errorMessage]="getUsernameErrorMessage()"
        (valueChange)="usernameControl()?.setValue($event!)" />

      <!-- Password Input -->
      <component-input
        type="password"
        label="Password"
        [value]="password()"
        [isClearable]="true"
        [errorMessage]="passwordError()"
        (valueChange)="onPasswordChange($event!)"
        (enter)="onRegister()" />

      <!-- Register button -->
      <component-button-with-loading
        cssClass="btn btn-primary btn-lg w-100"
        [disabled]="isFormInvalid() || isLoading()"
        [isLoading]="isLoading()"
        (click)="onRegister()">
        Complete Registration
      </component-button-with-loading>

      <p class="text-center small mb-0">
        By signing up, you agree to our
        <a [routerLink]="loginRoutes.terms()" class="link">Terms</a> &
        <a [routerLink]="loginRoutes.privacyPolicy()" class="link">Privacy Policy</a>.
      </p>
    </form>
  </ng-container>
</component-modal>
